/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './DiscreteLink.style';

import BaseLink from './BaseLink';
import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  layoutClass?: string,
  href: string,
  handleClick?: () => void,
  handleMouseOver?: () => void,
  children: React.Node,
};

const useStyles = createUseStyles(styles);

const DiscreteLink = ({
  layoutClass,
  href,
  handleClick,
  handleMouseOver,
  children,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <BaseLink
      className={classNames(classes.root, layoutClass)}
      href={href}
      handleClick={handleClick}
      handleMouseOver={handleMouseOver}
    >
      {children}
      <span className={classes.border} />
    </BaseLink>
  );
};

export default compose(React.memo)(DiscreteLink);
